import client from './client'

export interface User {
  id: number
  openid: string
  nickname: string
  avatar_url?: string
  coins: number
  invite_code: string
  invited_by?: number
  created_at: string
  updated_at: string
}

export interface Order {
  id: number
  user_id: number
  title: string
  description?: string
  coin_cost: number
  status: 'voting' | 'approved' | 'rejected' | 'purchased'
  created_at: string
  updated_at: string
}

export interface LedgerEntry {
  id: number
  user_id: number
  delta: number
  reason: string
  created_at: string
}

export interface SystemConfig {
  key: string
  value: string
  description?: string
  updated_at: string
}

export interface AdminStats {
  total_users: number
  total_orders: number
  total_coins_in_circulation: number
}

export interface PaginationParams {
  page?: number
  page_size?: number
}

// 用户管理
export async function listUsers(params?: PaginationParams): Promise<User[]> {
  return client.get('/api/admin/users', { params })
}

export async function adjustCoins(userId: number, amount: number, reason?: string) {
  return client.patch(`/api/admin/users/${userId}/coins`, { amount, reason })
}

// 订单管理
export async function listOrders(params?: PaginationParams & { status?: string }): Promise<Order[]> {
  return client.get('/api/admin/orders', { params })
}

export async function updateOrderStatus(orderId: number, status: string) {
  return client.patch(`/api/admin/orders/${orderId}/status`, { status })
}

// 账本
export async function listLedger(params?: PaginationParams): Promise<LedgerEntry[]> {
  return client.get('/api/admin/ledger', { params })
}

// 配置管理
export async function getConfigs(): Promise<SystemConfig[]> {
  return client.get('/api/admin/configs')
}

export async function updateConfig(key: string, value: string, description?: string) {
  return client.patch(`/api/admin/configs/${key}`, { value, description })
}

// 统计数据
export async function getStats(): Promise<AdminStats> {
  return client.get('/api/admin/stats')
}

// 演示数据 CSV 导入
export interface SeedPreview {
  valid: boolean
  errors: string[]
  warnings: string[]
  users_count: number
  orders_count: number
  votes_count: number
  users_sample: Record<string, string>[]
  orders_sample: Record<string, string>[]
  votes_sample: Record<string, string>[]
  votes_duplicate_pairs: number
}

export interface SeedImportResult {
  users: number
  orders: number
  votes_added: number
  votes_skipped: number
}

function postSeedImport(path: string, form: FormData): Promise<SeedPreview | SeedImportResult> {
  const token = localStorage.getItem('token')
  return client.post(path, form, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'multipart/form-data'
    }
  })
}

export async function previewSeedImport(form: FormData): Promise<SeedPreview> {
  return postSeedImport('/api/admin/seed-import/preview', form) as Promise<SeedPreview>
}

export async function applySeedImport(form: FormData): Promise<SeedImportResult> {
  return postSeedImport('/api/admin/seed-import/apply', form) as Promise<SeedImportResult>
}
